import useAAAtoastsNotifications from './useAAAtoastsNotifications';
import useTestAlertsToastsNotifications from './useTestAlertsToastsNotifications';
import useTrainIncidentToastsNotifications from './useTrainIncidentToastsNotifications';

const useAlertsToastNotifications = () => {
  useAAAtoastsNotifications();
  useTrainIncidentToastsNotifications();
  useTestAlertsToastsNotifications();
};

export default useAlertsToastNotifications;
